import { OfferCalculator } from "./offer-calculator";

export class OfferTermCalculator extends OfferCalculator {
    protected getAnnualRate(): number {
        return this.rate / 100;
    }

    protected getMonthlyRate(): number {
        return this.annualRate / 12;
    }

    protected getTotalInterest(term: number): number {
        return this.calculatorService.getTermLoanTotalInterest(this.applicationOffer, term, this.amount);
    }

    protected getTermPayment(): number {
        return this.calculatorService.getTermLoanPayment(this.amount, this.totalInterest, this.totalNumberOfPayments);
    }

    protected initSampleDraw(): void {
        this._sampleDraw = this.amount;
    }

    protected getCommission(): number {
        return this.amount * this.applicationOffer.maxUpsell / 100;
    }

    override get disbursedAmount(): number {
        return this.amount - this.drawFee - this.originationFeeAmount;
    }

    get totalPayback(): number {
        return this.amount + this.totalInterest;
    }

    override get drawFee(): number {
        return this.calculatorService.calculateFeeAmount(this.amount, this.fee, this.feeType);
    }

    override get amount(): number {
        return this._amount;
    }

    override set amount(value: number) {
        if (value > this.maxAmount)
            this._amount = this.maxAmount;
        else if (value < this.minAmount)
            this._amount = this.minAmount;
        else
            this._amount = value;
        this.calculatorService.notifyInputDataChanged();
    }
}
